<script>
export default {
  data() {
    return {
      section0: false,
      section1: false,
      section2: false,
    };
  },

  mixins: [],

  computed: {},

  created() {},

  mounted() {},

  watch: {},

  methods: {},

  components: {},
};
</script>
